import axios from 'axios';

const API_BASE_URL = 'https://preprod-api.speechsensepro.com';

const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

// Auth API calls
export const authAPI = {
  login: (email, turnstileToken) => {
    return api.post('/support/login', { email, turnstile_token: turnstileToken });
  },

  verifyOTP: (otp) => {
    return api.post('/support/verify', { otp });
  },

  checkAuth: () => {
    return api.get('/support/auth/check');
  },

  logout: () => {
    return api.post('/support/logout');
  },
};

// Tickets API calls
export const ticketsAPI = {
  createTicket: (data) => {
    return api.post('/api/tickets', data, {
      headers: { 'Content-Type': 'application/json' },
    });
  },

  getTickets: (params = {}) => {
    return api.get('/support/tickets', { params });
  },

  getTicket: (uuid) => {
    return api.get(`/support/tickets/${uuid}`);
  },

  updateTicket: (uuid, data) => {
    return api.put(`/support/tickets/${uuid}`, data);
  },

  replyToTicket: (uuid, content, authType = 'support') => {
    const basePath = authType === 'api' ? '/api/tickets' : '/support/tickets';
    return api.post(`${basePath}/${uuid}/reply`, { content }, {
      headers: { 'Content-Type': 'application/json' },
    });
  },

  uploadFile: (file, ticketUuid = null, authType = 'support') => {
    const formData = new FormData();
    formData.append('file', file);
    if (ticketUuid) {
      formData.append('ticketUuid', ticketUuid);
    }

    const uploadPath = authType === 'api' ? '/api/tickets/upload' : '/support/tickets/upload';
    return api.post(uploadPath, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },

  downloadFile: (ticketUuid, fileUuid) => {
    return api.get(`/support/tickets/${ticketUuid}/files/${fileUuid}`, {
      responseType: 'blob',
    });
  },
};

export default api;
